module.exports = __webpack_public_path__ + "assets/img/diploma-150px.7fed044a.webp";